/**
 *
 * Asynchronously loads the component for Overview
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Overview = lazyLoad(
  () => import('./index'),
  module => module.Overview,
);
